import { Dispatch, SetStateAction } from 'react'
import { Token } from '../../types/user-types'
import fetchApi from './api'
import { maybeAnEmailAddress } from './form-utils'

const FAKE_AUTH_STORAGE_KEY = 'fake-auth'
// TODO: Get from local storage?
const TOKEN_AUTH_STORAGE_KEY = 'api-key'
const TARGET_URL_KEY = 'NZWELLS_TARGET_URL'
export const UNKNOWN_TOKEN = 'UNKNOWN'
export const COUNCIL_NOT_ENABLED = 'DISABLED'

export function fakeAuthEnabled() {
  const fakeAuthMethod = process.env.REACT_APP_FAKE_AUTH
  return fakeAuthMethod === 'local'
}

export function setFakeAuthToken(token: string) {
  if (fakeAuthEnabled()) {
    localStorage.setItem(FAKE_AUTH_STORAGE_KEY, token)
  }
}

export function getFakeAuthToken(): Token {
  if (!fakeAuthEnabled()) return UNKNOWN_TOKEN

  return localStorage.getItem(FAKE_AUTH_STORAGE_KEY) || false
}

export function getTokenAuthToken(): Token | null {
  return localStorage.getItem(TOKEN_AUTH_STORAGE_KEY)
}

export function clearTokenAuthToken(): void {
  localStorage.removeItem(TOKEN_AUTH_STORAGE_KEY)
}

export function clearFakeAuthToken(): void {
  localStorage.removeItem(FAKE_AUTH_STORAGE_KEY)
}

export function setForwardingPath(path: string) {
  localStorage.setItem(TARGET_URL_KEY, path)
}

export function getForwardingPath(): string | null {
  return localStorage.getItem(TARGET_URL_KEY)
}

export function clearForwardingPath(): void {
  localStorage.removeItem(TARGET_URL_KEY)
}

export function authButtonHandlerFactory(pathname: string, setIsModalOpen: Dispatch<SetStateAction<boolean>>) {
  return () => {
    if (fakeAuthEnabled()) {
      // If forwarding path has already been set from another page, then use that
      setForwardingPath(getForwardingPath() || pathname)
      window.location.href = `${process.env.REACT_APP_SERVER_ADDRESS}/fake-auth/login`
    } else {
      // Sign in modal will look after the appropriate forwarding path
      setIsModalOpen(true)
    }
  }
}

export function isValidToken(token?: Token): boolean {
  return !!(token && token !== UNKNOWN_TOKEN)
}

interface EmailDomainRealmMap {
  emailDomain: string
  realmName: string
  enabled: boolean
}

export async function getUserIDP(loginHint: string) {
  if (!maybeAnEmailAddress(loginHint)) {
    return
  }

  const councilRealms: EmailDomainRealmMap[] = await fetchApi({ url: 'users/council-realms', token: '' })
  if (councilRealms.length) {
    const suppliedEmailDomain = loginHint.split('@')[1].trim()
    const matchingRealm = councilRealms.find(
      (realm) => realm.emailDomain.toLowerCase() === suppliedEmailDomain.toLowerCase(),
    )
    if (matchingRealm) {
      return matchingRealm.enabled ? matchingRealm.realmName : COUNCIL_NOT_ENABLED
    }
  }
}
